<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  <p class="add">Agregadas con exito: </p>  
  <ul>
    <li *ngFor="let etiqueta of data.added">{{ etiqueta }}</li>
  </ul>
  <p>Ya existentes en el proyecto:</p>
  <ul>
    <li *ngFor="let etiqueta of data.duplicate">{{ etiqueta }}</li>
  </ul>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cerrar</button>
</mat-dialog-actions>